export default function displayPrice(expense, payer, ignoreConsider = false) {
    if (payer !== expense.payer) {
        return '';
    }
    if (!ignoreConsider && expense.consider === false) {
        return `0 (${expense.price}) €`;
    }
    return `${expense.price} €`;
}
